import { render, staticRenderFns } from "./PDatePicker.vue?vue&type=template&id=bae69c36"
import script from "./PDatePicker.vue?vue&type=script&lang=js"
export * from "./PDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports